import { render, staticRenderFns } from "./updHsct2.vue?vue&type=template&id=5a9dda6e"
import script from "./updHsct2.vue?vue&type=script&lang=js"
export * from "./updHsct2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports